import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import { Address } from '../models/address.model';

export interface UserData {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL?: string;
  phoneNumber?: string;
  createdAt: string;
  role?: 'aarvya_admin' | 'aarvya_user';
  /**
   * The current list of addresses for the user.
   * This is the preferred field for multiple address management.
   */
  addresses?: Address[];
  
  /**
   * Legacy singular address field.
   * @deprecated Use `addresses` array instead.
   */
  address?: Address;
  referralSource?: string | null;
}

export interface UpdateUserPayload {
  displayName?: string;
  phoneNumber?: string;
  address?: Address;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.backendUrl}/users`;

  createUser(userData: UserData): Observable<UserData> {
    return this.http.post<UserData>(this.apiUrl, userData);
  }

  getUser(uid: string): Observable<UserData> {
    return this.http.get<UserData>(`${this.apiUrl}/${uid}`);
  }

  updateProfile(uid: string, data: Partial<UserData> | UpdateUserPayload): Observable<UserData> {
    return this.http.patch<UserData>(`${this.apiUrl}/${uid}`, data);
  }

  // --- Address Management --- //

  addAddress(uid: string, address: Address): Observable<UserData> {
     return this.http.post<UserData>(`${this.apiUrl}/${uid}/addresses`, address);
  }

  updateAddress(uid: string, addressId: string, address: Partial<Address>): Observable<UserData> {
    return this.http.patch<UserData>(`${this.apiUrl}/${uid}/addresses/${addressId}`, address);
  }

  deleteAddress(uid: string, index: number): Observable<UserData> {
    return this.http.post<UserData>(`${this.apiUrl}/${uid}/addresses/remove`, { index });
  }

  // --- Orders --- //
  getOrders(): Observable<any[]> { // Replace 'any' with Order interface if available shared
    return this.http.get<any[]>(`${environment.backendUrl}/orders/my-orders`);
  }
}
